<div class="product-page clearfix" data-testing-id="product-detail-page" itemscope itemtype="http://schema.org/Product">
  @if (productLoading$ | async) {
  <ish-loading />
  } @if (product$ | async; as product) {
  <div>
    <!--Dias Customization Starts -->
    <div class="marketing-area">
      <ish-content-viewcontext
        viewContextId="viewcontext.include.product.base.top"
        [callParameters]="{ Product: product.sku }"
      />
    </div>
    <!--Dias Customization Ends -->
    <ish-breadcrumb />
    <ish-product-detail />
    <!--Dias Customization Starts -->
    <div class="marketing-area">
      <ish-content-viewcontext
        viewContextId="viewcontext.include.product.content.top"
        [callParameters]="{ Product: product.sku }"
      />
    </div>
    <!--Dias Customization Ends -->
    <ish-product-bundle-parts />
    <ish-retail-set-parts />
    <ish-product-detail-info />
    <div *ishNotFeature="'productVariationList'">
      <ish-product-master-variations />
    </div>
    <div *ishFeature="'productVariationList'">
      <custom-lazy-master-product-variation />
    </div>
    <ish-product-links />
    <!--Dias Customization Starts -->
    <div class="marketing-area">
      <ish-content-viewcontext
        viewContextId="viewcontext.include.product.content.bottom"
        [callParameters]="{ Product: product.sku }"
      />
    </div>
    <!--Dias Customization Ends -->
    @if ((productLoading$ | async) !== true) {
    <ish-lazy-recently-viewed />
    }
    <!--Dias Customization Starts -->
    <div class="marketing-area">
      <ish-content-viewcontext
        viewContextId="viewcontext.include.product.base.bottom"
        [callParameters]="{ Product: product.sku }"
      />
    </div>
    <!--Dias Customization Ends -->
  </div>
  }
</div>
